import { IEnvironment } from './interfaces';

export const environment: IEnvironment = {
  baseUrl: '/3.0/',
  contactBaseUrl: '/3.1/',
  threeDotOneBaseUrl: '/3.1/',
  paymentIntegrationWebhookBaseUrl: `/`,
  resourcesUrlPrefix: '/',
  clientId: 'AZAVISTA-IDENTITY',
  production: true,

  // Gets overridden by the build system - DO NOT TOUCH
  sentryRelease: 'testing.2026-07-23-01-50-26',
};
